/**
 * Please avoid doing any modifications to this code as it might break webpack`s code optimization
 */
export const importEntryPoint = () => {
  /**
   * DefinePlugin in webpack.config.js will substitute
   * process.env.REACT_APP_BUILD_TARGET with it`s value at build time.
   * https://webpack.js.org/plugins/define-plugin/
   */

  /**
   * TerserPlugin in webpack.config.js will eliminate dead code
   * ...if we make it easy enough (no maps or switches, etc).
   * https://webpack.js.org/plugins/terser-webpack-plugin/
   */

  /**
   * Make sure REACT_APP_BUILD_TARGET environment variable values are in sync with those in "check-config.js"
   */
  if (process.env.REACT_APP_BUILD_TARGET === 'admin') {
    return import('@admin/app');
  } else if (process.env.REACT_APP_BUILD_TARGET === 'user') {
    return import('@user/app');
  } else {
    return Promise.reject(
      new Error(`No such build target: ${process.env.REACT_APP_BUILD_TARGET}`),
    );
  }
};
